import React from "react";
import {
  getFolderLabel,
  ORGANIZATION_FILE_TYPE
} from "../../../../config/helper";
import FolderIcon from "@material-ui/icons/Folder";
import { Link } from "react-router-dom";

export default function OrganizationFileTypeGrid({ entities = [] }) {
  const hasFile = type => {
    const folderHasFile = entities.some(
      file => file.type == ORGANIZATION_FILE_TYPE[type]
    );
    return folderHasFile;
  };

  return (
    <>
      <div
        className="mb-16"
        style={{
          display: "flex",
          flexWrap: "wrap"
        }}
      >
        {Object.keys(ORGANIZATION_FILE_TYPE).map(key => (
          <>
            <Link
              to={`/?type=${ORGANIZATION_FILE_TYPE[key]}`}
              className="d-flex flex-column cursor-pointer p-4"
              style={{
                flex: "0 1 23%",
                margin: 4,
                textAlign: "center",
                textDecoration: "none",
                color: "#000",
                border: "1px solid",
                borderRadius: 10,
                borderColor: hasFile(key) ? "#1BC5BD" : "#F64E60"
              }}
            >
              <div
                className="p-4 h-100"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center"
                }}
              >
                <FolderIcon
                  className="w-50"
                  style={{
                    fontSize: 60,
                    color: hasFile(key) ? "#1BC5BD" : "#F64E60"
                  }}
                />
              </div>
              <div
                className="mt-2"
                style={{
                  textAlign: "center",
                  fontSize: 14,
                  marginTop: "auto",
                  color: hasFile(key) ? "#1BC5BD" : "#F64E60"
                }}
              >
                {getFolderLabel(ORGANIZATION_FILE_TYPE[key])}
              </div>
            </Link>
          </>
        ))}
      </div>
    </>
  );
}
